import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactUsShellComponent } from './containers/contact-us-shell/contact-us-shell.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { ContactUsRoutingModule } from './contact-us-routing.module';
import { PageHeadingModule } from '../../components/page-heading/page-heading.module';
import { ConfirmationModule } from '../../components/confirmation/confirmation.module';
import { ContactUsPriorityShellComponent } from './containers/contact-us-priority-shell/contact-us-priority-shell.component';

const comps = [ContactUsShellComponent, ContactUsComponent, ContactUsPriorityShellComponent];
@NgModule({
  declarations: [...comps],
  exports: [...comps],
  imports: [CommonModule, ContactUsRoutingModule, PageHeadingModule, ConfirmationModule],
})
export class ContactUsModule {}
